import { templateCommands } from './templateCommands';
import { templatePanels } from './templatePanels';

export const templatesPlugin = editor => {
  templateCommands(editor);
  templatePanels(editor);
};
